import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback } from 'react';
import { cancelFiletransfers } from '../redux/devices/items/actions';
import { Button, Table, TableBody, TableCell, TableRow } from '@mui/material';
import { CloseRounded } from '@mui/icons-material';
import { LinearProgressWithLabel } from 'console/device-settings/z3k/components/material-utils/linear-progress-with-label';
import { useAction } from 'shared/hooks/redux/hooks';
export const firmware_types_titles = {
    firmware: 'Загрузка прошивки',
    soundpack: 'Загрузка звуков',
    fix_hw205_amr: 'Загрузка звуков',
    'log.txt': 'Загрузка лога',
    '': 'Загрузка файлов',
};
export function FileTransfersTable(props) {
    const { device_id, filetransfers, online } = props;
    const _onCancelFiletransfers = useAction(cancelFiletransfers);
    const onCancelFiletransfers = useCallback((transfer_id) => {
        _onCancelFiletransfers(device_id, { id: transfer_id });
    }, [device_id]);
    return (_jsx(Table, { children: _jsx(TableBody, { children: filetransfers
                .filter((transfer) => !transfer.done)
                .map((transfer) => {
                const percent = ~~(transfer.progress * 100);
                return (_jsxs(TableRow, { children: [_jsx(TableCell, { children: firmware_types_titles[transfer.type] ??
                                firmware_types_titles[''] }), _jsxs(TableCell, { children: [online && (_jsx(LinearProgressWithLabel, { value: percent, color: "error" })), _jsx(Button, { size: "small", startIcon: _jsx(CloseRounded, {}), sx: { ml: 1 }, onClick: () => onCancelFiletransfers(transfer.id) })] })] }, transfer.id));
            }) }) }));
}
